import axios from 'axios';

import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';
import { createActionType } from '../../utils/redux';

export const CREATE_STEP_PENDING = 'CREATE_STEP_PENDING';
export const CREATE_STEP_FAIL = 'CREATE_STEP_FAIL';
export const CREATE_STEP_SUCCESS = 'CREATE_STEP_SUCCESS';

export const UPDATE_STEP_PENDING = 'UPDATE_STEP_PENDING';
export const UPDATE_STEP_FAIL = 'UPDATE_STEP_FAIL';
export const UPDATE_STEP_SUCCESS = 'UPDATE_STEP_SUCCESS';

export const GET_STEPS_PENDING = 'GET_STEPS_PENDING';
export const GET_STEPS_FAIL = 'GET_STEPS_FAIL';
export const GET_STEPS_SUCCESS = 'GET_STEPS_SUCCESS';

export const DESTROY_STEP = createActionType('DESTROY_STEP');

export const createStep = (params = {}) => async (dispatch) => {
  dispatch({
    type: CREATE_STEP_PENDING,
    payload: {},
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}steps/`,
      params, { withCredentials: true },
    );
    dispatch({
      type: CREATE_STEP_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const destroyStep = stepId => async (dispatch) => {
  try {
    dispatch({ type: DESTROY_STEP.pending });
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}steps/${stepId}/`,
      { withCredentials: true },
    );
    dispatch({ type: DESTROY_STEP.success, payload: { id: stepId } });
  } catch (error) {
    handleErrors(error, dispatch);
    dispatch({ type: DESTROY_STEP.error });
  }
};

export const getSteps = (params = {}) => async (dispatch) => {
  dispatch({
    type: GET_STEPS_PENDING,
    payload: {},
  });
  const fetchUrl = `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}steps/`;

  try {
    const response = await axios.get(`${fetchUrl}`, { params, withCredentials: true });
    dispatch({
      type: GET_STEPS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_STEPS_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const updateStep = (stepId, params = {}) => async (dispatch) => {
  dispatch({
    type: UPDATE_STEP_PENDING,
    payload: {},
  });
  try {
    const response = await axios.patch(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}steps/${stepId}/`,
      params, { withCredentials: true },
    );
    dispatch({
      type: UPDATE_STEP_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_STEP_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};
